export class Urls {
  static feedback = "/feedback/create";
  static ping = "/ping"
}
